<template>
  <div>
    <h1>DATOS DE IDENTIFICACIÓN</h1>
    <table class="table" v-if="project != null">
      <thead>
      </thead>
      <tbody>
        <tr>
          <td>Nombre</td>
          <td>
            <input type="text" class="form-control" id="first_name" placeholder="Nombre" v-model="project.first_name">
          </td>
          <td>Apellidos</td>
          <td>
            <input type="text" class="form-control" id="last_name" placeholder="Apellidos" v-model="project.last_name">
          </td>
        </tr>
        <tr>
          <td>Tipo de documento</td>
          <td>
            <b-form-select v-model="project.person_id_type" :options="selects.id_types" class="form-control" value-field="person_id_type" text-field="name"></b-form-select>
          </td>
          <td>Documento</td>
          <td>
            <input type="text" class="form-control" id="person_id" placeholder="Apellidos" v-model="project.person_id">
          </td>
        </tr>
        <tr>
          <td>Sexo</td>
          <td>
            <b-form-select v-model="project.gender" :options="selects.genders" class="form-control" value-field="id" text-field="name"></b-form-select>
          </td>
          <td>Estado civil</td>
          <td>
            <b-form-select v-model="project.civil_type" :options="selects.civil_types" class="form-control" value-field="id" text-field="name"></b-form-select>
          </td>
        </tr>
        <tr>
          <td>Ciudad de expedición</td>
          <td>
            <select-local :model.sync="project.identification_city_id" :items="selects.cities"/>
          </td>
          <td>Fecha de expedición</td>
          <td>
            <input type="date" class="form-control" id="identification_expedition_date" placeholder="Apellidos" v-model="project.identification_expedition_date">
          </td>
        </tr>
        <tr>
          <td>Fecha de nacimiento</td>
          <td>
            <input type="date" class="form-control" id="birth_date" v-model="project.birth_date">
          </td>
          <td>Ciudad de nacimiento</td>
          <td>
            <select-local :model.sync="project.birth_city_id" :items="selects.cities"/>
          </td>
        </tr>
        <tr>
          <td>Libreta militar #</td>
          <td>
            <input type="text" class="form-control" id="militar_id" placeholder="#" v-model="project.militar_id">
          </td>
          <td>Clase</td>
          <td>
            <input type="text" class="form-control" id="militar_class" placeholder="Primera / Segunda" v-model="project.militar_class">
          </td>
        </tr>
        <tr>
          <td>Grupo sanguíneo</td>
          <td>
            <b-form-select v-model="project.blood_type" :options="selects.blood_types" class="form-control" value-field="blood_type" text-field="name"></b-form-select>
          </td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Teléfono 1</td>
          <td>
            <input type="text" class="form-control" id="telephone_1" placeholder="Nombre" v-model="project.telephone_1">
          </td>
          <td>Teléfono 2</td>
          <td>
            <input type="text" class="form-control" id="telephone_2" placeholder="Apellidos" v-model="project.telephone_2">
          </td>
        </tr>
        <tr>
          <td>Email 1</td>
          <td>
            <input type="text" class="form-control" id="email_1" placeholder="Nombre" v-model="project.email_1">
          </td>
          <td>Email 2</td>
          <td>
            <input type="text" class="form-control" id="email_2" placeholder="Apellidos" v-model="project.email_2">
          </td>
        </tr>
      </tbody>
    </table>
    <b-button variant="primary" @click.prevent="save">Guardar</b-button>
		<div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'
import SelectLocal from './../../own/select-local.vue'

export default {
  name: 'InformationPersonal',
  props: ['project_id', 'assignment_id'],
  computed: {
    ...mapGetters(['projectId', 'assignmentId', 'project', 'assignment', 'selects'])
  },
  data() {
    return {
			message: '',
			typeMessage: ''
    }
  },
  components: {
    'select-local': SelectLocal,
  },
  methods: {
    ...mapMutations(['changeProjectId', 'changeAssignmentId', 'changeProject', 'changeAssignment', 'changeSelects']),
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    getInformationWork() {
      console.log("1***")
      if (this.project_id != null && this.assignment_id != null) {
        axios.get(`/information_work.json?project_id=${this.project_id}&assignment_id=${this.assignment_id}`).then(res=>{
          if(res.status == 200){
            this.changeProjectId(this.project_id)
            this.changeAssignmentId(this.assignment_id)
            this.changeProject(res.data.project)
            this.changeAssignment(res.data.assignment)
            this.changeSelects(res.data.selects)
          }
        })        
      }else{
        console.log("No entro")
      }
    },
    save(){
      this.defaultAxios()
      let project = this.project
      delete project.family_compositions
      delete project.family_references
      delete project.family_sicks
      delete project.working_condition
      delete project.laboral_references
      delete project.family_interviews
			axios.put(`/update_information_personal`, { project: project }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Proceso actualizado', 'alert-success')
				}else{
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('El registro no se pudo actualizar', 'alert-danger')
      })
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},    
  },
  created () {
    this.getInformationWork();
  },
  watch: {
    data(newValue, oldValue) {

    }
  },
  filters: {
    fnName: function(value) {
      return value;
    }
  }
}
</script>

<style scoped>

</style>